import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { PopoverPosition } from "@blueprintjs/core";
import { Tooltip } from "@blueprintjs/core";
import { omit } from "lodash";
import { stepsListSelector } from "store/recipe/recipe.selectors";
import { getStepTitleAndColor } from "store/recipe/recipe.utils";
import ClipIcon from "icons/paper-clip.svg";
import * as styles from "./styles.module.scss";
const ReferencesLabel = ({ steps = [], liquidsCount = 0, customVariablesCount = 0, nodeName, className, }) => {
    const stepsList = useSelector(stepsListSelector);
    const stepsToDisplay = useMemo(() => steps.reduce((acc, step) => {
        const existedTypeIndex = acc.findIndex(({ type }) => step.type === type);
        if (existedTypeIndex !== -1) {
            acc[existedTypeIndex] = {
                type: acc[existedTypeIndex].type,
                count: acc[existedTypeIndex].count + 1,
            };
        }
        else {
            acc.push({ type: step.type, count: 1 });
        }
        return acc;
    }, []), [steps]);
    const totalCount = useMemo(() => steps.length + liquidsCount + customVariablesCount, [steps, liquidsCount, customVariablesCount]);
    return (React.createElement(Tooltip, { minimal: true, openOnTargetFocus: false, content: React.createElement("div", { className: styles.tooltipContent },
            React.createElement("p", { className: styles.title },
                "This ",
                nodeName,
                " is used in:"),
            React.createElement("ul", { className: styles.list },
                stepsToDisplay.map(({ type, count }, index) => (React.createElement("li", { key: index, className: styles["list-item"] },
                    getStepTitleAndColor(stepsList, type).title,
                    " step - ",
                    count))),
                liquidsCount > 0 && React.createElement("li", { className: styles["list-item"] },
                    "Liquids - ",
                    liquidsCount),
                customVariablesCount > 0 && (React.createElement("li", { className: styles["list-item"] },
                    "Custom Variables - ",
                    customVariablesCount)))), portalClassName: styles.tooltipPortal, popoverClassName: styles.tooltip, position: PopoverPosition.BOTTOM_LEFT, renderTarget: (props) => (React.createElement("div", { ...omit(props, "isOpen"), className: classNames(styles.tooltipTarget, props.className) },
            React.createElement("div", { className: classNames(styles.content, className) },
                React.createElement("p", { className: styles.text, "data-testid": "total-count" }, totalCount),
                React.createElement(ClipIcon, { className: styles.icon })))) }));
};
export default ReferencesLabel;
